export type RefreshableList = 'plans' | 'projects';

/** Per list: how many saves have happened that could change its rows. */
export type IListRefreshState = Record<RefreshableList, number>;

export const DefaultListRefreshState: IListRefreshState = {
  plans: 0,
  projects: 0
};
